import {inject} from '@angular/core';
import {CanActivateFn, RedirectCommand, Router} from '@angular/router';
import {UserAuthenticationService} from '../services/user-authentication.service';
import {BenutzerModels} from '../models/benutzer-models';

export const TimeAppPlusGuardGuard: CanActivateFn = async () => {
    const router = inject(Router);
    if (await inject(UserAuthenticationService).getCurrentAuthenticatedUser()?.allowRecordingMaterial) {
        return true;
    } else {
        return new RedirectCommand(router.parseUrl('login/403/timeappplus'));
    }
};
